import { UtilService } from 'src/app/util/UtilService';
import { Component } from '@angular/core';
import { TableInfopopupLayoutComponent } from '../core/tableinfopopup.layout.component';
import { OperatingSystemType } from 'src/app/constant/device.constant';

@Component({
    selector: 'app-tableinfopopuplayoutdesktop',
    templateUrl: './tableinfopopup.layout.desktop.component.html',
    styleUrls: ['../css/tableinfopopup.layout.desktop.component.scss'],
    standalone: false
})
export class TableInfopopupLayoutDesktopComponent extends TableInfopopupLayoutComponent {
  constructor(public utilService: UtilService) {
    super();
    this.isMac =
      this.utilService.getOSType() !== OperatingSystemType.MAC ? '' : 'mac';
  }

  tableheadArr: any[] = [
    {
      name: '$100 - $1,000',
    },
    {
      name: '8 DECKS',
    },
    {
      name: 'SHUFFLE 100%',
    },
    {
      name: 'SPLIT 5-9',
    },
    {
      name: 'SOFT 17',
    },
  ];
}
